import { Button, Modal, useTheme } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "@/components/Forms/components/ButtonMenu";
import { ApiKey } from "../api-keys.types";
import { CopyIcon } from "lucide-react";
import { useSnackbar } from "notistack";

export const DisplayApiKeyModal: React.FC<{
  show: boolean;
  onClose?: () => void;
  onSubmit?: (data: ApiKey) => void;
  onCancel?: () => void;
  defaultFormData?: ApiKey;
  buttonProps?: {
    submitText?: string;
    cancelText?: string;
  };
}> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  buttonProps = {},
  defaultFormData,
}) => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyApiKey = () => {
    navigator.clipboard.writeText(defaultFormData?.api_key || "");

    enqueueSnackbar("API Key copied to clipboard", {
      variant: "success",
    });
  };

  const handleSubmit = () => {
    !!defaultFormData && onSubmit?.(defaultFormData);
    onClose?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Title>New API Key</Modal.Title>
      <div>
        <div style={{ fontWeight: 500, marginTop: "10px" }}>
          Here is your new Monolith API key - please copy this in a secure
          location as this is the only time you will see it.
        </div>
        <div
          style={{
            fontWeight: 600,
            marginTop: "10px",
            marginBottom: "20px",
            fontStyle: "italic",
          }}
        >
          Please copy this API key and store it in a secure location as this is
          the only time you will see it.
        </div>
        <div
          style={{
            fontWeight: 600,
            marginTop: "10px",
            marginBottom: "20px",
          }}
        >
          ID: {defaultFormData?.uuid}
        </div>
        <div
          style={{
            margin: "0px auto",
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <div>API Key:</div>
          <div
            style={{
              fontFamily: "monospace",
              padding: "5px 10px",
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: "5px",
              backgroundColor: theme.palette.background.alt,
            }}
          >
            {defaultFormData?.api_key}
          </div>
          <Button
            size="xs"
            variant="outlined"
            leftSection={<CopyIcon size={14} />}
            onClick={handleCopyApiKey}
          >
            Copy
          </Button>
        </div>
      </div>

      <ButtonMenu style={{ marginTop: "20px", justifyContent: "center" }}>
        <Button
          size="xs"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          {buttonProps?.submitText || "Close"}
        </Button>
      </ButtonMenu>
    </Modal>
  );
};
